define(
    'views/reseller-locator-controller',[
        'jquery',
        'utils/view'      
    ],

    function ($, View) {
        var ResellerLocator = (function() {
            function ResellerLocator() {}
                
            ResellerLocator.prototype.init = function() {    
                var heightArray = [];
                var resellerTab;
                
                // Show first or single location list on load
                $('.location:nth-child(1)').addClass('active');
                $('.location-list:nth-child(1)').addClass('active');
                        
                $('.location-list__details').each(function (i) {
                    resellerTab = $(this);                   
                    heightArray[i] = resellerTab.outerHeight();
                                      
                    resellerTab.css('height', 0);                                  
                });

                // Country selector tabs              
                $(".location").on("click", function() {
                    var index = $(this).index('.location') + 1;
                    
                    $('.location-list.active').removeClass('active').css('visibility','hidden'); 
                    $('.location').removeClass('active'); 
                    $('.col-container .location-list:nth-child('+index+')').addClass('active').css('visibility','visible');
                    $(this).addClass('active');     
                    
                    $('.location-list__header').removeClass('expand');
                    $('.location-list__details').css('height', 0);
                });   

                // City selector tabs
                $(".location-list__header").on("click", function() {      
                    resellerTab = $(".location-list__details");      
                    var index = $(this).index('.location-list__header');

                    if ( $(this).hasClass('expand') ) {
                        $(this).removeClass('expand');
                        $(this).next(resellerTab).css('height', 0);
                        
                    } else {
                        $(this).addClass('expand');
                        $(this).next(resellerTab).css('height', heightArray[index]);                    
                    }

                });              
            };

            return ResellerLocator;               
        })();

        return View('ResellerLocator', function () {                   
            var resellerLocator = new ResellerLocator();
            
            resellerLocator.init();
        });    

    }
);
